import { useRootData } from './use-root-data';
export const useIsGoodBot = () => {
    const isBot = useRootData().device.isBot;
    return isBot;
};
